import NoContent from "../common/NoContent";
import PurchaseHistoryItem from "./PurchaseHistoryItem";
import ContentTitle from "../common/ContentTitle";
import { useEffect, useState } from "react";
import DataProvider from "../../data_provider/DataProvider";
import { useNavigate } from "react-router";
import { useModal } from "../modal/Modal";
import ModalButtons from "../modal/ModalButtons";
import LoadingSpinner from "../common/LoadingSpinner";

export interface PurchaseInfo {
    userName: string;
    gradeName: string;
    grade: string;
    price: string;
    purchaseDate: string;
}

export interface PurchaseHistoryItem extends PurchaseInfo {
    expireDate: string;
    refundStatus: number;
    refundDate?: string;
}



const PurchaseHistory = () => {
    const navigate = useNavigate();
    const [data, setData] = useState<Array<PurchaseHistoryItem>>();
    const { ModalComponent, openModal, closeModal } = useModal();

    const showModal = (message: React.ReactNode) => {
        openModal({
            title: "오류",
            children: message,
            modalButtons: (
                <ModalButtons
                    buttonCount={1}
                    buttons={[
                        {
                            label: "확인",
                            color: "Danger",
                            onClick: () => closeModal(),
                        },
                    ]}
                />
            ),
        });
    };

    const onRefundClick = async (info: PurchaseInfo) => {
        openModal({
            title:"환불 처리중입니다. 잠시만 기다려 주세요.",
            children: <LoadingSpinner/>
        })
        const refund_result = await DataProvider.UpdateRefund(info);

        // pro버전을 사용하는 사용자의 경우에는 구독 취소도 함께 진행
        if (info.grade == "2") {
            await DataProvider.Unsubscribe();
        }

        if (refund_result.flag) {
            openModal({
                title: "안내",
                children: (
                    <>
                        구독 취소 및 환불이 접수되었습니다.
                        <br />
                        <br />
                        다음 결제일부터 요금이 청구되지 않습니다.
                        <br />더 나은 서비스를 위해 항상 노력하겠습니다.
                    </>
                ),
                modalButtons: (
                    <ModalButtons
                        buttonCount={1}
                        buttons={[
                            {
                                label: "확인",
                                color: "Primary",
                                onClick: () => {
                                    closeModal();
                                    getPurchaseHistory();
                                    navigate(0);
                                },
                            },
                        ]}
                    />
                ),
            });
        } else {
            // refund_result.status === 403 && navigate("/");

            // hmchoi 오류별 처리 구현
            switch (refund_result.status) {
                case 400:
                    showModal("잘못된 환불 요청입니다."); break;
                case 403:
                    showModal("로그인이 필요합니다."); navigate("/"); break;
                case 404:
                    showModal("구매내역을 찾을 수 없습니다."); break;
                case 500:
                    showModal("서버에서 해당 요청을 처리하지 못했습니다."); break;
                default:
                    showModal("일시적인 오류가 발생했습니다."); break;
            }

            return;
        }
    };

    useEffect(() => {
        getPurchaseHistory();
    }, []);

    /**
     * 사용자 구매 내역 조회
     * @param userId: 사용자아이디
     * @returns 사용자 구매 정보
     */
    const getPurchaseHistory = async () => {
        // const result = await DataProvider.GetPurhcaseList();
        // if (result.flag) {
        //     result.code === "OK" && setData(result.result);
        // } else {
        //     result.status === 403 && navigate("/");
        // }

        // hmchoi 오류별 처리 구현
        const response = await DataProvider.GetPurhcaseList();
        if (response.status === 204) {
            setData([]);
            return;
        }

        if (!response.flag) {
            switch (response.status) {
                case 403:
                    openModal({ title: "알림", children: "로그인이 필요합니다." }); navigate("/"); break;
                case 500:
                    openModal({ title: "오류", children: "결제 내역을 불러오는 중 오류가 발생했습니다." }); break;
                default:
                    openModal({ title: "오류", children: response.desc ?? "결제 내역을 불러오지 못했습니다." });
            }

            return;
        }

        setData(response.result);
    };

    return (
        <>
            <ContentTitle title="멤버십 구매 내역" />
            {data ? (
                data.map((item: any, index: number) => {
                    return <PurchaseHistoryItem data={item} key={`history_${index}`} onRefundClick={onRefundClick} />;
                })
            ) : (
                <NoContent msg={"구매 내역이 없습니다."} icon="money" />
            )}

            <ModalComponent />
        </>
    );
};

export default PurchaseHistory;
